import '../css/index.css';
import ConfigService from "./services/config-service";
import DialogService from "./services/dialog-service";

document.addEventListener("DOMContentLoaded", function () {

	const dialogService = new DialogService();

	dialogService.init();

	if (ConfigService.getConfig('showCookieBar')) {
		const cookieBar = document.querySelector('#js-cookie-bar');
		if (cookieBar !== null) {
			cookieBar.showModal();
		}
	}

	const filterToggle = document.querySelector('.js-filters-toggle');
	if (filterToggle !== null) {
		filterToggle.addEventListener('click', function (event) {
			event.preventDefault();
			const filtersContainer = document.querySelector('.js-filters-container');
			filtersContainer.classList.toggle('hidden');
		});
	}

});
